import MyPage from "../pages/MyPage";
import MyPageCompanyManage from "../pages/MyPageCompanyManage";
import MyPageSystemAuthority from "../pages/MyPageSystemAuthority";

import ManagerMyPage from "../pages/ManagerMyPage";
import ManagerMyPageCompanyManage from "../pages/ManagerMyPageCompanyManage";

import Commute from "../pages/Commute";

import ManagerCommuteMonitoring from "../pages/ManagerCommuteMonitoring";
import ManagerCommuteStatics from "../pages/ManagerCommuteStatics";
import ManagerCommuteStaticsCompany from "../pages/ManagerCommuteStaticsCompany";

import Performance from "../pages/Performance";
import PerformanceInvest from "../pages/PerformanceInvest";
import PerformanceSupport from "../pages/PerformanceSupport";
import PerformanceIntellectual from "../pages/PerformanceIntellectual";
import PerformanceTeam from "../pages/PerformanceTeam";
import PerformancePrize from "../pages/PerformancePrize";

import Board from "../pages/Board";
import BoardNetworking from "../pages/BoardNetworking";
import BoardShare from "../pages/BoardShare";
import BoardPlan from "../pages/BoardPlan";
import Reservation from "../pages/Reservation";

import HeaderExtra from "../components/HeaderExtra";

const mainMenus = [
  {
    path: "/my_page",
    label: "마이 페이지",
    iconAct: "mypage_act",
    iconDeact: "mypage_deact",
    element: <MyPage />,    
    authority: [2, 3, 4, 5, 6, 7],
    lowerMenu: [
      {
        path: "/",
        label: "대시보드페이지",
        variants: [ 
          {
            element: <MyPage />,
            authority: [2, 3, 4],
            headerExtra: <HeaderExtra.SearchExtra />,
          },
          {
            element: <ManagerMyPage />,
            authority: [5, 6, 7],
            headerExtra: <HeaderExtra.SearchExtra />,
          },
        ],
      },
      {
        path: "/company_manage",
        label: "입주기업 관리카드",
        disabled: true,
        variants: [
          {
            element: <MyPageCompanyManage />,
            authority: [2, 3, 4],
          },
          {
            element: <ManagerMyPageCompanyManage />,
            authority: [5, 6, 7],
            headerExtra: <HeaderExtra.WriteExtra text='엑셀 파일 다운로드' onRed={false} />,
          },
        ],
      },
      {
        path: "/system_authority",
        label: "권한 설정",
        element: <MyPageSystemAuthority/>,
        authority: [3, 4, 5, 6, 7]
      }
    ],
  },
  {
    path: "/commute",
    label: "출퇴근 체크",
    iconAct: "bus_act",
    iconDeact: "bus_deact",
    element: <Commute />,
    authority: [2, 3, 4, 5, 6, 7],
    lowerMenu: [
      {
        path: "/",
        label: "출퇴근체크",
        element: <Commute/>,
        authority: [2, 3, 4, 5, 6, 7],
        headerExtra : <HeaderExtra.SearchExtra/>,
      },
      {
        path: "/monitoring",
        label: "출퇴근 모니터링",
        element: <ManagerCommuteMonitoring/>,
        authority: [3, 4, 5, 6, 7],
        headerExtra : <HeaderExtra.SearchExtra/>,
      },
      {
        path: "/statistics_crew",
        label: "월별통계(유저)",
        element: <ManagerCommuteStatics/>,
        authority: [3, 4, 5,
          6, 7],
        headerExtra : <HeaderExtra.SearchExtra/>,
      },
      {
        path: "/statistics_company",
        label: "월별통계(기업)",
        element: <ManagerCommuteStaticsCompany/>,
        authority: [5, 6, 7],
        headerExtra : <HeaderExtra.SearchExtra/>,
      },
    ],
  },
  {
    path: "/performance",
    label: "성과 관리",
    iconAct: "performance_act",
    iconDeact: "performance_deact",
    element: <Performance />,
    authority: [2, 3, 4, 5, 6, 7],
    disabled: false,
    lowerMenu: [
      {
        path:"/",
        label: "매출관리",
        element: <Performance />,
        headerExtra: <HeaderExtra.WriteExtra text='신규작성'/>,
        headerExtra2: <HeaderExtra.WriteExtra text='엑셀 다운로드' onRed={false}/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/invest",
        label: "투자현황",
        element: <PerformanceInvest />,
        headerExtra: <HeaderExtra.WriteExtra text='신규작성'/>,
        headerExtra2: <HeaderExtra.WriteExtra text='엑셀 다운로드' onRed={false}/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/support",
        label: "지원사업 선정",
        element: <PerformanceSupport />,
        headerExtra: <HeaderExtra.WriteExtra text='신규작성'/>,
        headerExtra2: <HeaderExtra.WriteExtra text='엑셀 다운로드' onRed={false}/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/intellectual",
        label: "지식재산권",
        element: <PerformanceIntellectual />,
        headerExtra: <HeaderExtra.WriteExtra text='신규작성'/>,
        headerExtra2: <HeaderExtra.WriteExtra text='엑셀 다운로드' onRed={false}/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/team",
        label: "팀원관리",
        element: <PerformanceTeam />,
        headerExtra: <HeaderExtra.WriteExtra text='신규작성'/>,
        headerExtra2: <HeaderExtra.WriteExtra text='엑셀 다운로드' onRed={false}/>,
        authority: [2, 3, 4, 5, 6, 7],
      },      
      {
        path: "/prize",
        label: "수상실적",
        element: <PerformancePrize />,
        headerExtra: <HeaderExtra.WriteExtra text='신규작성'/>,
        headerExtra2: <HeaderExtra.WriteExtra text='엑셀 다운로드' onRed={false}/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
    ],
  },
  {
    path: "/board",
    label: "게시판",
    iconAct: "board_act",
    iconDeact: "board_deact",
    element: <Board />,
    authority: [2, 3, 4, 5, 6, 7],
    disabled: true,
    lowerMenu: [
      {
        path: "/",
        label: "공지사항 게시판",
        variants: [ 
          {
            element: <Board />,
            authority: [2, 3, 4],
          },
          {
            element: <Board />,
            authority: [5, 6, 7],
            headerExtra: <HeaderExtra.WriteExtra text='글쓰기'/>,
          },
        ],
        // element: <Board />,
        // headerExtra: <HeaderExtra.WriteExtra text='글쓰기'/>,
        // authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/networking",
        label: "입주기업 네트워킹 게시판",
        element: <BoardNetworking />,
        headerExtra: <HeaderExtra.WriteExtra text='글쓰기'/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/share",
        label: "창업관련정보 공유게시판",
        element: <BoardShare />,
        headerExtra: <HeaderExtra.WriteExtra text='글쓰기'/>,
        authority: [2, 3, 4, 5, 6, 7],
      },
      {
        path: "/plan",
        label: "프로그램 일정 게시판",
        element: <BoardPlan />,
        headerExtra: <HeaderExtra.SearchExtra/>,
        authority: [2, 3, 4, 5, 6, 7],
      }
    ]
  },
  {
    path: "/reservation",
    label: "좌석 예약",
    iconAct: "calendar_selected",
    iconDeact: "calendar",
    element: <Reservation />,
    authority: [2, 3, 4, 5, 6, 7],
  },
];
  
export default mainMenus;
